import React from 'react';
import SidebarItem from './SidebarItem';
import tabsConfig from '../config/tabsConfig';
import { useTranslation } from '../utils/languageUtils';

const Sidebar = ({ activeTab, setActiveTab, showStickersTab, configData }) => {
  const { t } = useTranslation();
  
  
  // Check if we have themes available (fallback check)
  const hasThemes = configData && configData.Themes && configData.Themes.length > 0;
  const shouldShowStickers = showStickersTab || hasThemes;
  
  
  
  // Filter tabs that should appear in the sidebar
  // Only show stickers tab when we have stickers available
  const tabs = tabsConfig.filter(tab => {
    if (tab.id === 'stickers') {
      
      if (!shouldShowStickers) {
        
        return false;
      }
    }
    return tab.showInSidebar;
  });

  // If no tabs are marked for sidebar, don't render anything
  if (tabs.length === 0) {
    return null;
  }
  
  // Toggle tab function - simpler now that we're using conditional rendering
  const toggleTab = (tabId) => {
    // If clicking the currently active tab, toggle it off
    if (activeTab === tabId) {
      setActiveTab(null);
    } else {
      setActiveTab(tabId);
    }
  };

  // Check if device is mobile
  const isMobile = window.innerWidth <= 768;

  // Prevent iOS touch events from causing sidebar dragging
  const handleTouchMove = (e) => {
    // Prevent default touch behavior on iOS
    e.preventDefault();
  };

  return (
    <div 
      className="sidebar"
      onTouchMove={handleTouchMove}
      // Additional iOS-specific attributes
      onTouchStart={(e) => e.stopPropagation()}
    >
      {tabs.map(tab => (
        <SidebarItem
          key={tab.id}
          item={{
            id: tab.id,
            icon: tab.icon,
            label: tab.label
          }}
          isActive={activeTab === tab.id}
          onClick={() => toggleTab(tab.id)}
        />
      ))}
    </div>
  );
};

export default Sidebar;